var v1="<div class=\"form-group\"> <div class=\"checkbox checbox-switch switch-primary\"> <label class=\"{{ vm.settings.disabled || vm.disabled ? 'checkbox-disable-field' : '' }}\"> <input type=\"checkbox\" name=\"{{ vm.settings.dataAt }}\" id=\"{{ vm.settings.dataAt }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled || vm.disabled\" ng-required=\"vm.settings.required\">\n<span></span>\n<b>{{ vm.settings.displayName }}</b> </label> </div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\" ng-bind-html=\"vm.settings.helpText\"></p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaSwitch/lbaSwitch.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaSwitch/lbaSwitch.html
// module id = 249
// module chunks = 0